/* eslint-disable indent */
export function colKeyToName(key) {
  switch (key) {
    // Bundle
    case "driveReference":
      return "msizer.ui.drive_reference";
    case "motorReference":
      return "msizer.ui.motor_reference";
    case "gearboxReference":
      return "msizer.ui.gearbox_reference";
    case "adaptationKitRef":
      return "msizer.ui.adaptation_kit_reference";
    case "nominalTorque":
      return "msizer.ui.bundle_nominal_torque";
    case "nominalTorqueReserve":
      return "msizer.ui.nominal_torque_reserve";
    case "nominalSpeed":
      return "msizer.ui.bundle_nominal_speed";
    case "nominalSpeedReserve":
      return "msizer.ui.nominal_speed_reserve";
    case "length":
      return "msizer.ui.bundle_length";

    // Motor
    case "motorType":
      return "msizer.ui.motor_filters.motor_type";
    case "inertiaRatio":
      return "msizer.ui.inertia_ratio";
    case "bundleInertia":
      return "msizer.ui.bundle_inertia";
    case "motorLength":
      return "msizer.ui.motor_filters.motor_length";
    case "flangeSize":
      return "msizer.ui.motor_filters.flange_size";
    case "shaftEnd":
      return "msizer.ui.motor_filters.shaft_end";
    case "ipProtections":
      return "msizer.ui.motor_filters.ip_degree_of_protection";
    case "holdingBrake":
      return "msizer.ui.motor_filters.holding_brake";
    case "motorEncoder":
      return "msizer.ui.motor_filters.encoder";
    case "connector":
      return "msizer.ui.motor_filters.connector_type";
    case "nominalTorqueOfMotor":
      return "msizer.ui.motor_filters.nominal_torque_of_motor";
    case "continuousStallTorque":
      return "msizer.ui.motor_filters.continuous_stall_torque";
    case "peakStallTorque":
      return "msizer.ui.motor_filters.peak_stall_torque";
    case "nominalSpeedOfMotor":
      return "msizer.ui.motor_filters.nominal_speed_of_motor";
    case "inertiaMotor":
      return "msizer.ui.motor_filters.inertia";
    case "motorComponentType":
      return "msizer.ui.motor_filters.component_type";
    case "numberOfStacks":
      return "msizer.ui.motor_filters.number_of_stacks";
    case "maximumMechanicalSpeed":
      return "msizer.ui.motor_filters.maximum_mechanical_speed";
    case "motorSupplyVoltage":
      return "msizer.ui.motor_filters.supply_voltage";
    case "shaftDiameter":
      return "msizer.ui.motor_filters.shaft_diameter";
    case "shaftLength":
      return "msizer.ui.motor_filters.shaft_length";
    case "motorWeight":
      return "msizer.ui.motor_filters.weight";
    case "continuousStallCurrent":
      return "msizer.ui.motor_filters.continuous_stall_current";
    case "speedFeedbackResolution":
      return "msizer.ui.motor_filters.speed_feedback_resolution";
    case "motorOutputCurrent3SPeak":
      return "msizer.ui.motor_filters.output_current_3s_peak";

    // Gearbox
    case "gearboxRatio":
      return "msizer.ui.gearbox_filters.reduction_ratio";
    case "gearboxFamily":
      return "msizer.ui.gearbox_filters.short_name";
    case "gearboxType":
      return "msizer.ui.gearbox_filters.gearbox_type";
    case "inputDiameter":
      return "msizer.ui.gearbox_filters.input_diameter";
    case "externalDiameter":
      return "msizer.ui.gearbox_filters.external_diameter";
    case "gearboxEfficiency":
      return "msizer.ui.gearbox_filters.efficiency";
    case "gearboxTorsionalBacklash":
      return "msizer.ui.gearbox_filters.maximum_torsional_backlash";
    case "gearboxComponentType":
      return "msizer.ui.gearbox_filters.component_type";
    case "shaftMomentOfInertia":
      return "msizer.ui.gearbox_filters.shaft_moment_of_inertia";
    case "gearboxNetWeight":
      return "msizer.ui.gearbox_filters.net_weight";
    case "continuousOutputTorque":
      return "msizer.ui.gearbox_filters.continuous_output_torque";
    case "maximumOutputTorque":
      return "msizer.ui.gearbox_filters.maximum_output_torque";
    case "gearboxIpDegreeOfProtection":
      return "msizer.ui.gearbox_filters.ip_degree_of_protection";
    case "gearboxLength":
      return "msizer.ui.gearbox_filters.length";

    // Drive
    case "driveType":
      return "msizer.ui.drive_filters.drive_type";
    case "supplyVoltage":
      return "msizer.ui.drive_filters.supply_voltage";
    case "interface":
      return "msizer.ui.drive_filters.communication_interfaces";
    case "current":
      return "msizer.ui.drive_filters.output_current";
    case "switchingFreq":
      return "msizer.ui.drive_filters.switching_frequency";
    case "format":
      return "msizer.ui.drive_filters.format";
    case "driveRangeOfProduct":
      return "msizer.ui.drive_filters.range_of_product";
    case "driveComponentType":
      return "msizer.ui.drive_filters.component_type";
    case "driveSupplyVoltage":
      return "msizer.ui.drive_filters.supply_voltage";
    case "nbPhases":
      return "msizer.ui.drive_filters.nb_phases";
    case "nominalPower":
      return "msizer.ui.drive_filters.nominal_power";
    case "driveNetWeight":
      return "msizer.ui.drive_filters.net_weight";
    case "driveDepth":
      return "msizer.ui.drive_filters.depth";
    case "driveHeight":
      return "msizer.ui.drive_filters.height";
    case "driveWidth":
      return "msizer.ui.drive_filters.width";
    case "lineCurrent":
      return "msizer.ui.drive_filters.line_current";
    case "driveOutputCurrent3SPeak":
      return "msizer.ui.drive_filters.output_current_3s_peak";

    // Adaptation kit
    case "adaptationKitComponentType":
      return "msizer.ui.adaptation_kit_attributes.component_type";
    case "separatePartDestination":
      return "msizer.ui.adaptation_kit_attributes.separate_part_destination";
    case "adaptationKitLength":
      return "msizer.ui.adaptation_kit_attributes.length";
    case "kitComposition":
      return "msizer.ui.adaptation_kit.kit_composition";
    case "kitFlangeSize":
      return "msizer.ui.adaptation_kit.flange_size";
    case "adaptationKitWeight":
      return "msizer.ui.adaptation_kit_attributes.weight";

    // Integrated drives
    case "PRODUCT_CODE":
      return "msizer.ui.integrated_drives_attributes.product_code";
    case "T_COMMUNICATION_INTERFACE":
      return "msizer.ui.integrated_drives_attributes.communication_interface";
    case "TC_VOLTAGE":
      return "msizer.ui.integrated_drives_attributes.voltage";
    case "T_OFFER_TYPE":
      return "msizer.ui.integrated_drives_attributes.drive_type";
    case "T_ENCODER_TYPE":
      return "msizer.ui.integrated_drives_attributes.encoder";
    case "T_NUMBER_OF_MOTOR_STACKS":
      return "msizer.ui.integrated_drives_attributes.number_of_motor_stacks";
    case "T_HOLDING_BRAKE":
      return "msizer.ui.integrated_drives_attributes.holding_brake";
    case "TC_LENGTH":
      return "msizer.ui.integrated_drives_attributes.length";
    case "T_SHAFT_TYPE":
      return "msizer.ui.integrated_drives_attributes.shaft_type";
    case "TASHAFT_TYPE":
      return "msizer.ui.integrated_drives_attributes.shaft_type";
    case "T_MOTOR_FLANGE_SIZE":
      return "msizer.ui.integrated_drives_attributes.motor_flange_size";
    case "TC_NOMINAL_SPEED":
      return "msizer.ui.integrated_drives_attributes.nominal_speed";
    case "TC_NOMINAL_TORQUE":
      return "msizer.ui.integrated_drives_attributes.nominal_torque";

    default:
      return key;
  }
}

export function colKeyToFilter(key) {
  switch (key) {
    // Motor
    // case "motorType":
    //   return "motorType";
    case "nominalTorque":
      return "nominalTorque";
    // case "maxTorque":
    //   return "maxTorque";
    case "nominalSpeed":
      return "nominalSpeed";
    // case "nominalSpeed":
    //   return "nominalSpeed";
    case "inertiaRatio":
      return "inertia";
    case "motorLength":
      return "length";
    // case "flangeSize":
    //   return "flangeSize";
    // case "shaftEnd":
    //   return "shaftEnd";
    // case "ipDegree":
    //   return "ipDegree";
    // case "holdingBrake":
    //   return "holdingBrake";
    // case "motorEncoder":
    //   return "motorEncoder";
    // case "connector":
    //   return "connector";

    // Gearbox
    // case "gearboxManufacturer":
    //   return "gearboxManufacturer";
    // case "gearboxType":
    //   return "gearboxType";
    // case "gearboxRatio":
    //   return "gearboxRatio";
    // case "precision":
    //   return "precision";
    // case "specification":
    //   return "specification";
    case "length":
      return "length";

    // Drive
    // case "driveType":
    //   return "driveType";
    case "supplyVoltage":
      return "supplyVoltage";
    // case "interface":
    //   return "interface";
    // case "current":
    //   return "current";

    default:
      return "none";
  }
}
